import instObj from '@/backend/axios-instances'

const resource = "/orders/details/bom"
const instance = instObj.baseInstance

export default {
  get(orderDetailBomId, parameters) {
    return instance.get(`${resource}/${orderDetailBomId}`, { params: parameters });
  },
  put(orderDetailBomId, data, parameters) {
    return instance.put(`${resource}/${orderDetailBomId}`, data, { params: parameters });
  },
  delete(orderDetailBomId) {
    return instance.delete(`${resource}/${orderDetailBomId}`);
  }
}
